import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import { useMutation, useQueryClient } from "react-query";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../../models/common.model";

import createCache from "@emotion/cache";
import { createStyles, makeStyles } from "@material-ui/core";
import { Box, Button, FormControl, Grid, Tooltip } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { createTheme } from "@mui/material/styles";
import { Formik } from "formik";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import ChipCmp from "../../../components/chip/chipCmp";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import { TABLE_FILTER } from "../../../config/cacheKey";
import { PaginationInfo } from "../../../models/cartable.model";
import DropdownCmp2 from "../../../components/dropdown/DropdownCmp2";
import DatePickerComponents from "../../../components/datePicker/DatePickerComponents";
import { CacheProvider, ThemeProvider } from "@emotion/react";
import AutocomplateCheckbox from "../../../components/dropdown/AutocomplateCheckbox";
import { convertToLocalDateTime } from "../../../utility/dateUtility";
import { getAllBanks } from "../../../services/dropdown.service";
import { IDropdownResponse } from "../../../models/dropdown.model";
import {
  Filter,
  GetChequeRequest,
  GetChequeResponse,
} from "../../../models/cheque.model";
import {
  GetCheques,
  GetChequesExportToExcel,
} from "../../../services/cheque.service";
import { getEnumsPersian } from "../../../services/enum.services";
import { GetEnumsResponse } from "../../../models/enum.model";
import PriceFeildComponent from "../../../components/priceFeild/priceFeildComponent";

const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Previous.png" />
  );
};

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const columns: readonly ColumnModel[] = [
  { id: "isDigitalTitle", label: "نوع چک" },
  { id: "chequeTypeTitle", label: "بابت" },
  {
    id: "amount",
    label: "مبلغ چک",
    hasFormat: true,
    format: (value: number) => {
      return value?.toLocaleString("fa");
    },
  },
  {
    id: "dueDate_Persian",
    label: "تاریخ سررسید",
  },
  {
    id: "bankTitle",
    label: "بانک",
  },
  {
    id: "sayadNumber",
    label: "شماره صیادی",
  },
  {
    id: "ibanNumber",
    label: "شماره شبا",
  },
  {
    id: "seriesNo",
    label: "شماره سری چک",
  },
  {
    id: "serialNo",
    label: "شماره سریال چک",
  },
  {
    id: "signer",
    label: "امضا کننده",
  },
  {
    id: "excpectedHolderName",
    label: "دروجه",
  },
];
let muiSelected: any;

export default function ChequeReport() {
  const jsonFile = useSelector((state: any) => state.style);
  const useStyles = makeStyles((theme) =>
    createStyles({
      select: {
        "&.Mui-selected": {
          backgroundColor: muiSelected + "!important",
        },
      },
    })
  );
  const classes = useStyles();
  const [valueFilterData, setValueFilterData] = React.useState<Filter>();
  const [valueChequeType, setValueChequeType] = useState<string>();
  const [valueIsDigital, setValueIsDigital] = useState<any>();
  const [isDigitalToChip, setisDigitalToChip] = useState<string>();
  const [valueAmountFrom, setValueAmountFrom] = useState<number | undefined>();
  const [valueAmountTo, setValueAmountTo] = useState<number | undefined>();
  const [dueDate, setDueDate] = useState<Date[] | null | undefined>(null);
  const [valueDueDate, setValueDueDate] = useState<string>();
  const [bankOption, setBankOption] = React.useState<IDropdownResponse[]>([]);
  const [valueBankId, setValueBankId] = React.useState<any[]>([]);
  const [valueBankTitle, setValueBankTitle] = React.useState<string[]>([]);
  const [bankResponse, setBankResponse] = React.useState<any[]>([]);
  const [valueSayadNumber, setValueSayadNumber] = React.useState<string>();
  const [valueIbanNumber, setValueIbanNumber] = React.useState<string>();
  const [valueSeriesNo, setValueSeriesNo] = React.useState<string>();
  const [valueSerialNo, setValueSerialNo] = React.useState<string>();
  const [chequeTypes, setChequeTypes] = useState<GetEnumsResponse[]>();
  const [valueChequeTypeTitle, setValueChequeTypeTitle] = useState<string>();

  const isDigitalOptions = [
    { title: "کاغذی", id: 1, enumData: "false" },
    { title: "دیجیتال", id: 2, enumData: "true" },
  ];
  const removeNonNumeric = (num: any) => num?.toString().replace(/[^0-9]/g, "");
  const queryClient = useQueryClient();
  const history = useHistory<{
    from: string;
    id: number;
    pageNumber: number;
    clickOnBack: boolean;
    saleKey: string;
    branchId: number;
    customerPersonId: number;
  }>();
  const [data, setData] = useState<GetChequeResponse[]>([]);
  const previousPage =
    history.location.state !== undefined ? history.location.state.from : null;
  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber =
        history.location.state != undefined
          ? history.location.state.pageNumber
          : 1;
      return paginationInfo;
    }
  );

  React.useEffect(() => {
    let filterData;
    if (
      previousPage !== null ||
      (history.action === "REPLACE" &&
        history.location.state !== undefined &&
        history.location.state.clickOnBack)
    ) {
      filterData = queryClient.getQueryData<Filter>(TABLE_FILTER);
      if (filterData !== undefined && filterData !== null) {
        setValueChequeType(filterData!.chequeType!);
        setValueIsDigital(filterData!.isDigital!);
        setValueAmountFrom(filterData!.amountFrom!);
        setValueAmountTo(filterData!.amountTo!);
        setValueDueDate("");
        setValueBankId(filterData!.bankCodes!);
        setBankResponse(filterData!.bankCodes!);
        setValueSayadNumber(filterData!.sayadNumber!);
        setValueFilterData(filterData);
        setValueIbanNumber(filterData!.ibanNumber!);
        setValueSerialNo(filterData!.serialNo!);
        setValueSeriesNo(filterData!.seriesNo!);
      }
    } else {
      filterData = null;
      let filter = new Filter();
      queryClient.setQueryData(TABLE_FILTER, filter);
      filter.amountFrom = undefined;
      filter.amountTo = undefined;
      filter.bankCodes = [];
      filter.sayadNumber = undefined;
      filter.ibanNumber = undefined;
      filter.seriesNo = undefined;
      filter.serialNo = undefined;

      setValueFilterData(filter);
    }
    fillData(filterData!);
    const getBanks = {} as IDropdownResponse;
    GetAllBanksMutate(getBanks);
    getEnumsPersianMutate({
      enumNames: ["ChequeType"],
    });
  }, []);
  const { mutate: getEnumsPersianMutate } = useMutation(getEnumsPersian, {
    onSuccess: (data: GetEnumsResponse[]) => {
      if (data) {
        setChequeTypes(data);
      }
    },
    onError: () => {},
  });

  const { mutateAsync: GetChequesMutate } = useMutation(GetCheques, {
    onSuccess: (data: ApiResultModel<GetChequeResponse[]>) => {
      setData(data.data);
      setPageInfo(data.pageInfo);
    },
  });

  const GetChequesExportToExcelMutate = useMutation(GetChequesExportToExcel, {
    onSuccess: (result) => {},
    onError: (e) => {},
  });

  const generateFilter = (filterData: Filter): GetChequeRequest => {
    let request = new GetChequeRequest();
    request.paginationInfo = currentPaginationInfo;
    request.filter = filterData;
    return request;
  };

  const fillData = (filterData: Filter) => {
    let filter = generateFilter(filterData);
    GetChequesMutate(filter);
    setValueFilterData(filter?.filter);
  };

  const changePageNumber = (newPageNumber: number) => {
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    fillData(tabelFilter!);
    currentPaginationInfo.pageNumber = newPageNumber;
    setCurrentPaginationInfo(currentPaginationInfo);
  };

  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
  };

  function deleteChip() {
    setValueChequeTypeTitle("");
    setisDigitalToChip("");
    setValueChequeType(undefined);
    setValueIsDigital(undefined);
    setValueAmountFrom(undefined);
    setValueAmountTo(undefined);
    setValueDueDate("");
    setValueBankId([]);
    setValueBankTitle([]);
    setBankResponse([]);
    setValueSayadNumber("");
    setValueIbanNumber("");
    setValueSerialNo("");
    setValueSeriesNo("");
    let filter = new Filter();
    queryClient.setQueryData(TABLE_FILTER, filter);
    fillData(queryClient.getQueryData(TABLE_FILTER)!);
    currentPaginationInfo.pageNumber = 1;
    setCurrentPaginationInfo(currentPaginationInfo);
  }
  const filter = new Filter();
  filter.chequeType = "";

  const handleDetail = (referenceKey: string) => {
    window.sessionStorage.setItem("idFind", referenceKey);
    const newWindow = window.open(
      "/#/Search/SupplierSearch1/request-find-detail",
      "_blank"
    );
    newWindow?.history.pushState(
      {
        id: referenceKey,
      },
      "",
      "/Search/SupplierSearch1/request-find-detail"
    );
  };
  const [isShow, setIsShow] = useState(true);
  let handelFilter = () => {
    setIsShow(!isShow);
  };

  let exportExcel = () => {
    GetChequesExportToExcelMutate.mutate(
      valueFilterData ? valueFilterData! : new Filter()
    );
  };

  const setChildValueChequeType = (childValues: any) => {
    setValueChequeType(undefined);
    setValueChequeTypeTitle(undefined);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter !== undefined && tabelFilter !== null)
      tabelFilter!.chequeType = undefined;
    fillData(tabelFilter!);
  };
  const setChildValueIsDigital = (childValues: any) => {
    setValueIsDigital(undefined);
    setisDigitalToChip(undefined);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter !== undefined && tabelFilter !== null)
      tabelFilter!.isDigital = undefined;
    fillData(tabelFilter!);
  };
  const setChildValueAmountFrom = (childValues: any) => {
    setValueAmountFrom(undefined);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter !== undefined) tabelFilter!.amountFrom = undefined;
    fillData(tabelFilter!);
  };
  const setChildValueAmountTo = (childValues: any) => {
    setValueAmountTo(undefined);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter !== undefined) tabelFilter!.amountTo = undefined;
    fillData(tabelFilter!);
  };
  const setChildValueDueDate = (childValues: any) => {
    setValueDueDate("");
    setDueDate(undefined);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter !== undefined) {
      tabelFilter!.dueDateFrom = undefined;
      tabelFilter!.dueDateTo = undefined;
    }
    fillData(tabelFilter!);
  };

  const setChildValueBank = (childValues: any) => {
    const delValue = bankOption.filter(
      (item: any) => item.title === childValues
    );
    const updateResponse = bankResponse.filter(
      (item: any) => item.additionalData !== delValue[0].additionalData
    );
    setBankResponse(updateResponse);

    const selectedItem = valueBankId.filter(
      (item: any) => item !== delValue[0].additionalData
    );

    const titleValue = valueBankTitle.filter(
      (item: any) => item !== childValues
    );
    setValueBankTitle(titleValue);
    setValueBankId(selectedItem);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    const updatedFilter = tabelFilter?.bankCodes?.filter(
      (id: any) => id !== delValue[0].additionalData
    );
    if (updatedFilter !== undefined && updatedFilter !== null) {
      tabelFilter!.bankCodes = updatedFilter;
    }
    fillData(tabelFilter!);
  };

  const setChildValueSayadNumber = (childValues: any) => {
    setValueSayadNumber("");
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter !== undefined) tabelFilter!.sayadNumber = undefined;
    fillData(tabelFilter!);
  };
  const setChildValueIbanNumber = (childValues: any) => {
    setValueIbanNumber("");
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter !== undefined) tabelFilter!.ibanNumber = undefined;
    fillData(tabelFilter!);
  };
  const setChildValueSerialNo = (childValues: any) => {
    setValueSerialNo("");
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter !== undefined) tabelFilter!.serialNo = undefined;
    fillData(tabelFilter!);
  };
  const setChildValueSeriesNo = (childValues: any) => {
    setValueSeriesNo("");
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter !== undefined) tabelFilter!.seriesNo = undefined;
    fillData(tabelFilter!);
  };

  function changeValueChequeType(e: any) {
    setValueChequeType(e.target.value);
    if (e.target.value === 1) {
      setValueChequeTypeTitle("اقساط");
    } else if (e.target.value === 2) {
      setValueChequeTypeTitle("ضمانت");
    }
  }
  function changeValueAmountFrom(e: any) {
    setValueAmountFrom(
      removeNonNumeric(e.currentTarget.value).replace(/,/g, "")
    );
  }
  function changeValueAmountTo(e: any) {
    setValueAmountTo(removeNonNumeric(e.currentTarget.value).replace(/,/g, ""));
  }
  function changeValueIsDigital(e: any) {
    const val =
      e.target?.value === "true"
        ? true
        : e.target?.value === "false"
        ? false
        : e.target?.value;
    setValueIsDigital(val);
    let obj = isDigitalOptions.filter(
      (item) => item.enumData === e.target.value
    );
    setisDigitalToChip(obj[0]?.title);
  }
  function changeValueDueDate(e: any) {
    setDueDate(e);
    setValueDueDate(e.toString().replace(/,/g, " - "));
  }
  function changeValueBanks(e: any, value: any) {
    const additionalData = value.map((item: any) => item.additionalData);
    setValueBankId(additionalData);
    setValueBankTitle(value.map((item: any) => item.title));
    setBankResponse(value);
  }
  function changeValueSayadNumber(e: any) {
    setValueSayadNumber(e.currentTarget?.value);
  }
  function changeValueIbanNumber(e: any) {
    setValueIbanNumber(e.currentTarget?.value);
  }
  function changeValueSerialNo(e: any) {
    setValueSerialNo(e.currentTarget?.value);
  }
  function changeValueSeriesNo(e: any) {
    setValueSeriesNo(e.currentTarget?.value);
  }
  const { mutateAsync: GetAllBanksMutate } = useMutation(getAllBanks, {
    onSuccess: (data: IDropdownResponse[]) => {
      setBankOption(data);
    },
  });
  return (
    <div>
      <Tooltip title="فیلتر" arrow>
        <img
          onClick={handelFilter}
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src="images/filter.png"
        />
      </Tooltip>
      <span style={{ margin: "2vh", color: "#CFD8DC" }}>|</span>
      <Tooltip title="خروجی اکسل" arrow>
        <img
          onClick={exportExcel}
          className="cursorPointer"
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src="images/ExportXLS.svg"
        />
      </Tooltip>
      {isShow ? (
        <Box sx={{ flexGrow: 1 }}>
          <Formik
            initialValues={filter}
            onSubmit={(values: any) => {
              if (
                dueDate != null &&
                (dueDate[0] !== undefined || dueDate[1] !== undefined)
              ) {
                values.dueDateFrom = convertToLocalDateTime(Number(dueDate[0]));
                if (dueDate.length > 1) {
                  values.dueDateTo = convertToLocalDateTime(Number(dueDate[1]));
                } else {
                  values.dueDateTo = convertToLocalDateTime(Number(dueDate[0]));
                }
              } else {
                values.dueDateFrom = undefined;
                values.dueDateTo = undefined;
                values.dueDate = undefined;
              }
              values.chequeType = valueChequeType;
              values.isDigital = valueIsDigital;
              values.bankCodes = valueBankId;
              values.amountFrom = valueAmountFrom;
              values.amountTo = valueAmountTo;
              values.sayadNumber = valueSayadNumber;
              values.ibanNumber = valueIbanNumber;
              values.serialNo = valueSerialNo;
              values.seriesNo = valueSeriesNo;
              values.dueDate = valueDueDate;
              queryClient.setQueryData(TABLE_FILTER, values);
              fillData(values);
              currentPaginationInfo.pageNumber = 1;
              setCurrentPaginationInfo(currentPaginationInfo);
            }}
          >
            {({ handleSubmit, handleChange, values }) => (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 dropdownCmp2-container"
                    style={{ marginTop: "1vh" }}
                  >
                    <DropdownCmp2
                      style={{
                        paddingRight: "0 !important",
                      }}
                      onChange={changeValueIsDigital}
                      value={valueIsDigital ?? ""}
                      label={"نوع چک"}
                      options={isDigitalOptions}
                      name="isDigital"
                      id="isDigital"
                      darkTheme={true}
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 dropdownCmp2-container"
                    style={{ marginTop: "1vh" }}
                  >
                    <DropdownCmp2
                      style={{
                        paddingRight: "0 !important",
                      }}
                      onChange={changeValueChequeType}
                      value={valueChequeType ?? ""}
                      label={"بابت"}
                      options={chequeTypes}
                      name="chequeType"
                      id="chequeType"
                      // darkTheme={true}
                    />
                  </div>

                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <PriceFeildComponent
                          placeHolder={"مبلغ چک از (ریال)"}
                          label={"مبلغ چک از (ریال)"}
                          required={false}
                          value={valueAmountFrom ?? ""}
                          onChange={changeValueAmountFrom}
                          name="amountFrom"
                          id="amountFrom"
                          showPersianWords={false}
                        />
                      </ThemeProvider>
                    </CacheProvider>
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <PriceFeildComponent
                          helperText={""}
                          placeHolder={"مبلغ چک تا (ریال)"}
                          label={"مبلغ چک تا (ریال)"}
                          required={false}
                          value={valueAmountTo ?? ""}
                          onChange={changeValueAmountTo}
                          name="amountTo"
                          id="amountTo"
                          showPersianWords={false}
                        />
                      </ThemeProvider>
                    </CacheProvider>
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <FormControl fullWidth className="shadowDatepicker">
                      <DatePickerComponents
                        valueArray={dueDate}
                        label={"تاریخ سررسید"}
                        onChange={changeValueDueDate}
                        range={true}
                      />
                    </FormControl>
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 dropdownCmp2-container"
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div dir="rtl">
                          <AutocomplateCheckbox
                            id="bankCodes"
                            name="bankCodes"
                            value={valueBankId}
                            label={"بانک"}
                            options={bankOption}
                            onChange={changeValueBanks}
                            changeMultiSelect={changeValueBanks}
                            responseValue={bankResponse}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      helperText={""}
                      placeHolder={"شماره صیادی"}
                      label={"شماره صیادی"}
                      required={false}
                      value={valueSayadNumber}
                      onChange={changeValueSayadNumber}
                      name="sayadNumber"
                      id="sayadNumber"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      helperText={""}
                      placeHolder={"شماره شبا"}
                      label={"شماره شبا"}
                      required={false}
                      value={valueIbanNumber}
                      onChange={changeValueIbanNumber}
                      name="ibanNumber"
                      id="ibanNumber"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      helperText={""}
                      placeHolder={"شماره سریال چک"}
                      label={"شماره سریال چک"}
                      required={false}
                      value={valueSerialNo}
                      onChange={changeValueSerialNo}
                      name="serialNo"
                      id="serialNo"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      helperText={""}
                      placeHolder={"شماره سری چک"}
                      label={"شماره سری چک"}
                      required={false}
                      value={valueSeriesNo}
                      onChange={changeValueSeriesNo}
                      name="seriesNo"
                      id="seriesNo"
                    />
                  </div>

                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter"
                    style={{ paddingTop: "1vh" }}
                  >
                    <Button
                      fullWidth
                      variant="contained"
                      type="submit"
                      className="btnForm SuccessDefault  "
                    >
                      اعمال فیلتر
                    </Button>
                  </div>
                </div>

                {valueIsDigital !== undefined ||
                valueChequeType ||
                valueAmountFrom ||
                valueAmountTo ||
                valueDueDate ||
                valueSayadNumber ||
                valueIbanNumber ||
                valueSerialNo ||
                valueSeriesNo ||
                valueBankId?.length ? (
                  <div className="row tableCMP">
                    <Grid container xs={12}>
                      <Grid item xs={12} sm={0.5} style={{ marginTop: "20px" }}>
                        <Button
                          onClick={deleteChip}
                          style={{
                            justifyContent: "right",
                            minWidth: "25px",
                            marginRight: "-1vh",
                          }}
                        >
                          <img
                            style={{ height: "24px", width: "24px" }}
                            src="images/RemoveAllFilters.svg"
                          />
                        </Button>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={11.5}
                        style={{ marginTop: "10px" }}
                      >
                        <ChipCmp
                          item={isDigitalToChip}
                          enamValue={isDigitalToChip}
                          index={valueIsDigital?.length}
                          setChildValue={setChildValueIsDigital}
                        />
                        <ChipCmp
                          item={valueChequeTypeTitle}
                          enamValue={valueChequeTypeTitle}
                          index={valueChequeType?.length}
                          setChildValue={setChildValueChequeType}
                        />
                        <ChipCmp
                          item={valueAmountFrom}
                          enamValue={valueAmountFrom}
                          index={valueAmountFrom}
                          setChildValue={setChildValueAmountFrom}
                        />
                        <ChipCmp
                          item={valueAmountTo}
                          enamValue={valueAmountTo}
                          index={valueAmountTo}
                          setChildValue={setChildValueAmountTo}
                        />
                        <ChipCmp
                          item={valueDueDate}
                          enamValue={valueDueDate}
                          index={valueDueDate?.length}
                          setChildValue={setChildValueDueDate}
                        />
                        {valueBankTitle.map((title, index) => (
                          <ChipCmp
                            key={index}
                            item={title}
                            enamValue={title}
                            index={index}
                            setChildValue={setChildValueBank}
                          />
                        ))}
                        <ChipCmp
                          item={valueSayadNumber}
                          enamValue={valueSayadNumber}
                          index={valueSayadNumber?.length}
                          setChildValue={setChildValueSayadNumber}
                        />
                        <ChipCmp
                          item={valueIbanNumber}
                          enamValue={valueIbanNumber}
                          index={valueIbanNumber?.length}
                          setChildValue={setChildValueIbanNumber}
                        />
                        <ChipCmp
                          item={valueSerialNo}
                          enamValue={valueSerialNo}
                          index={valueSerialNo?.length}
                          setChildValue={setChildValueSerialNo}
                        />
                        <ChipCmp
                          item={valueSeriesNo}
                          enamValue={valueSeriesNo}
                          index={valueSeriesNo?.length}
                          setChildValue={setChildValueSeriesNo}
                        />
                      </Grid>
                    </Grid>
                  </div>
                ) : (
                  ""
                )}
              </form>
            )}
          </Formik>
        </Box>
      ) : (
        ""
      )}
      <br />

      <div className="cardTableBorder ">
        <TableContainer
          style={{ background: "#fff", direction: "rtl" }}
          className={`${data?.length > 0 ? "boxScrollSubmit" : ""}`}
        >
          <Table
            stickyHeader
            aria-label="sticky table "
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
              >
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight"
                  align="right"
                  style={{ width: "5px" }}
                >
                  ردیف
                </TableCell>
                {columns?.map((column) => (
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight nowrapClass"
                    key={column.id}
                    align="right"
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>

            <TableBody
              style={{
                height: "30px",
                minHeight: "30px",
              }}
            >
              {data?.map((row, rowIndex) => {
                return (
                  <TableRow
                    classes={{ root: classes.select }}
                    className={`${
                      rowIndex % 2 == 0
                        ? "rowTBodyE  borderRight borderLeft"
                        : "rowTBodyO  borderRight borderLeft"
                    }${classes} borderRight borderLeft cursorPointer noWrap`}
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    // key={row.loanRequestId}
                    // selected={selectedRow === rowIndex}
                    onClick={() => handleDetail(row.referenceKey!)}
                  >
                    <TableCell className="textFont12" style={{ width: "5px" }}>
                      {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                        (currentPaginationInfo.pageSize! ?? 0) +
                        rowIndex +
                        1}
                    </TableCell>
                    {columns?.map((column) => {
                      const value = row[column.id as keyof GetChequeResponse];
                      return (
                        <TableCell
                          className="textFont12 nowrapClass"
                          key={column.id}
                          align="right"
                        >
                          {column.format && column.hasFormat
                            ? column.format(value)
                            : value instanceof Date
                            ? value.toLocaleString()
                            : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div>
        <Grid container spacing={2} alignItems="center">
          <Grid
            item
            xs={12}
            sm={4}
            display="flex"
            justifyContent={{ xs: "center", sm: "flex-start" }}
          >
            <span
              style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
            >
              تعداد کل :
              <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
            </span>
          </Grid>
          <Grid item xs={12} sm={4} display="flex" justifyContent="center">
            <Pagination
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: previusIcon,
                    next: nextIcon,
                  }}
                  {...item}
                />
              )}
              // color="primary"
              sx={{
                direction: "ltr",
                margin: "5px",
                button: {
                  color: "#25D1C9",
                  fontSize: "14px !important",
                  fontFamily: "iranSans",
                },
              }}
              count={Math.ceil(pageInfo.total / pageInfo.pageSize)}
              onChange={handleChangePagination}
              page={currentPaginationInfo.pageNumber}
            />
          </Grid>
          <Grid item xs={12} sm={4}></Grid>
        </Grid>
      </div>
    </div>
  );
}
